import { faArrowLeft, faSchool } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@wfp/ui";
import Empty from "components/Empty";
import React from "react";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";

export default () => (
  <Empty
    icon={<FontAwesomeIcon icon={faSchool} />}
    title="User has no school"
    kind="large"
    button={
      <NavLink exact to={`/logout`}>
        <Button
          small
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          style={{ marginBottom: "0.75rem" }}
        >
          <FormattedMessage
            id="UserNavigation.logoutButtonLabel"
            defaultMessage="Logout"
          />
        </Button>
      </NavLink>
    }
  >
    <FormattedMessage
      id="UserHasNoSchool.explanation"
      defaultMessage="Your user is not related to a school. Please contact the administrator."
    />
  </Empty>
);
